module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/212-moldova-a897d59cc52bf58bc55c81bf5da2f57d.svg";